import { call, put } from 'redux-saga/effects';
import UserClient from '../../api/UserClient';
import { setOngoingTrips, setOngoingTripsLoading } from '../../redux/user/actions';
import { messagesShow } from '../../redux/messages/actions';
import { getOngoingTripReceiptsSaga } from '../billing/getOngoingTripReceiptsSaga';

export function* getOngoingTripsSaga() {
    try {
        const { journeys = [] } = yield call(UserClient.getOngoingTrips);
        const journeysIds = journeys.map(journey => journey.id);

        const ongoingTripsReceipts = yield call(getOngoingTripReceiptsSaga, { payload: journeysIds });

        // Set ongoing trips in the store only if there is at least one receipt
        if (Object.values(ongoingTripsReceipts).some(receipt => Object.keys(receipt).length > 0)) {
            yield put(
                setOngoingTrips({
                    ids: journeysIds,
                    data: journeys.reduce((acc, journey) => {
                        acc[journey.id] = journey;
                        return acc;
                    }, {}),
                })
            );
        }
    } catch (error) {
        console.error('Error in getOngoingTripsSaga:', error);
        yield put(messagesShow('billingPage.ongoingTripsPage.notifications.receiptsFetchError', 'error'));
    } finally {
        yield put(setOngoingTripsLoading(false));
    }
}
